import 'regenerator-runtime/runtime';
import { all } from 'redux-saga/effects';
import { watchStreckeSnapshot } from './streckeSnapshotSaga';
import { watchStateSnapshot } from './stateSnapshotSaga';
import { watchAntragsnummerRequested } from './antragsnummerSaga';
import { watchAnimalIllnessesRequested } from './animalIllnessesSaga';
import { watchProductRelevantDataChanged } from './productRelevantDataChangedSaga';
import { streckenTarifierungTkv } from './streckenTarifierungTkv';
import { watchProduktlinienSaga } from './produktlinienSaga';
import { watchContinueToDashboardSaga } from './continueToDashboardSaga';
import { shopTarifierungTkv } from './shopTarifierungTkv';
import { watchVorschlagdatenChangend } from './vorschlagdatenSaga';
import { watchDruckdatenChanged } from './druckdatenSaga';
import { watchVorbelegungRequested } from './vorbelegungSaga';
import { watchQuoteDB } from './quoteDbSaga';
import { handleTkvNavigationToAngebotSaga } from './handleTkvNavigationToAngebotSaga';
import { watchFetchTierrassenOnLoad } from './fetchTierrassenOnLoadSaga';
import { updateDashboardTierartAfterLoadSaga } from './updateDashboardTierartAfterLoadSaga';

export function* rootSaga() {
  yield all([
    watchStreckeSnapshot(),
    watchStateSnapshot(),
    watchAntragsnummerRequested(),
    watchAnimalIllnessesRequested(),
    watchProductRelevantDataChanged(),
    streckenTarifierungTkv(),
    shopTarifierungTkv(),
    watchProduktlinienSaga(),
    watchContinueToDashboardSaga(),
    watchVorschlagdatenChangend(),
    watchDruckdatenChanged(),
    watchVorbelegungRequested(),
    watchQuoteDB(),
    handleTkvNavigationToAngebotSaga(),
    watchFetchTierrassenOnLoad(),
    updateDashboardTierartAfterLoadSaga(),
  ]);
}
